import { render, staticRenderFns } from "./VendorManagementPurchaseChart.vue?vue&type=template&id=61b3b718&"
import script from "./VendorManagementPurchaseChart.vue?vue&type=script&lang=js&"
export * from "./VendorManagementPurchaseChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports